module.exports = __webpack_public_path__ + "img/Blog writing.e6ea9631.svg";